interface Link {
    target?: string;
    text?: string;
    url: string;
}

export interface Links {
    saveInFund: Link;
    contactAdvisor: Link;
}

export const links: Links = {
    saveInFund: {
        url: '/sparing-og-pensjon/fond',
    },
    contactAdvisor: {
        url: '/book-mote',
    },
};
